import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "8", r: "5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 21a8 8 0 1 0-16 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "User2";
const User2 = memo(themed(Icon));
export {
  User2
};
//# sourceMappingURL=user-2.js.map
